import { createFileRoute } from '@tanstack/react-router'
import { HandoffChat } from '../../../../components/HandoffChat'

export const Route = createFileRoute('/platform/desa/$desaId/percakapan')({
  component: () => {
    const { desaId } = Route.useParams()
    return <HandoffChat desaId={desaId} />
  },
})
